<div class="revision-search-view container-fluid d-flex align-items-center justify-content-center py-4">
    <div class="search-wrapper w-100">

        <div class="card search-card">
            <div class="card-body p-4 p-md-5 text-center">


                <span class="eyebrow">Consulta tu orden de trabajo</span>
                <h1 class="search-title">MI OT</h1>
                <p class="search-subtitle mb-4">
                    Ingresa la patente de tu vehículo para ver el estado de tu orden.
                </p>

                <label for="patenteInput" class="visually-hidden">Patente del vehículo</label>
                <div class="input-group input-group-lg search-group">

                    <input #patenteInput id="patenteInput" type="text"
                        class="form-control plate-input text-center text-uppercase" [class.is-invalid]="error"
                        placeholder="ABCD12" maxlength="6" autocomplete="off" autocapitalize="characters"
                        autocorrect="off" spellcheck="false" enterkeyhint="search"
                        aria-describedby="patenteHelp patenteError" [attr.aria-invalid]="error ? 'true' : null"
                        (input)="onInput(patenteInput)" (keyup.enter)="buscar(patenteInput.value)" />
                    <button class="btn btn-revision-primary" type="button" [disabled]="patenteInput.value.length < 6"
                        (click)="buscar(patenteInput.value)">
                        <i class="fas fa-search me-2"></i>
                    </button>
                </div>

                <small id="patenteHelp" class="search-help d-block mt-3" *ngIf="!error">
                    Ej: <strong>ABCD12</strong> o <strong>AB1234</strong>
                </small>

                <small id="patenteError" class="search-error d-block mt-3" role="alert" aria-live="polite"
                    *ngIf="error">
                    <i class="fas fa-circle-exclamation me-1"></i>{{ error }}
                </small>

            </div>
        </div>

    </div>
</div>